import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import './header.css';
import logo from "../../Images/Logo.png";

export default function Header() {
    // const auth = useSelector((state) => state.auth);
    const auth = JSON.parse(localStorage.getItem('login'));
    const isLogged = auth ? auth.isLogged : false;
    const [click, setClick] = useState(false);
    const handleLogout = async () => {
        try {
            await axios.get('https://iq-screener-backend-a7au.vercel.app/api/user/logout');
            localStorage.removeItem("firstLogin");
            localStorage.removeItem("login");
            localStorage.removeItem("userEmail");
            localStorage.removeItem("dataType");
            localStorage.removeItem("dataAlert");
            window.location.href = "/";
        } catch (err) { }
    };

    const handleClick = () => setClick(!click);
    const Close = () => setClick(false);
    
    return (
        <div>
            <div className={click ? "main-container" : ""} onClick={() => Close()} />
            <nav className="navbar" onClick={e => e.stopPropagation()}>
                <div className="nav-container">
                    <Link exact to="/" className="nav-logo" activeClassName="active">
                        <img src={logo}/>
                    </Link>
                    <div className="Seperator"></div>
                    <ul className={click ? "nav-menu active" : "nav-menu"}>

                        { isLogged ? 
                        <>
                            <li className="nav-item">
                                <Link esxact to="/about" activeClassName="active" className="nav-links" onClick={click ? handleClick : null}>
                                    About
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link esxact to="/profile" activeClassName="active" className="nav-links" onClick={click ? handleClick : null}>
                                    Profile
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link exact to="/" activeClassName="active" className="nav-links" onClick={handleLogout}>
                                    Logout
                                </Link>
                            </li>
                        </>
                        :
                        <>
                            <li className="nav-item">
                                <Link esxact to="/demo" activeClassName="active" className="nav-links" onClick={click ? handleClick : null}>
                                    Demo
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link esxact to="/about" activeClassName="active" className="nav-links" onClick={click ? handleClick : null}>
                                    About
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link exact to="/login" activeClassName="active" className="nav-links" onClick={click ? handleClick : null}>
                                    Login
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link exacts to="/register" activeClassName="active" className="nav-links" onClick={click ? handleClick : null}>
                                    Register
                                </Link>
                            </li>

                        </>
                        }
                    </ul>
                    <div className="nav-icon" onClick={handleClick}>
                        <i className={click ? "fa fa-times" : "fa fa-bars"}></i>
                    </div>
                </div>
            </nav>
        </ div>

    )
}
